import { RouteConfig } from "vue-router";

const scheduleManagement = () =>
  import("@/views/page/scheduleManagement/scheduleNotice/index.vue");
const BookingSituation = () =>
  import("@/views/page/scheduleManagement/BookingSituation/index.vue");
const scheduleSummary = () =>
  import("@/views/page/scheduleManagement/scheduleSummary/index.vue");
const resumeManagement = () =>
  import("@/views/page/resumeManagement/index.vue");
const resumeList = () => import("@/views/page/resumeList/index.vue");
const auditionList = () => import("@/views/page/auditionList/index.vue");
const hrRegister = () => import("@/views/page/hr-personal/hr-register.vue");
const hrChangePassword = () =>
  import("@/views/page/hr-personal/hr-changepassword.vue");
const smsList = () => import("@/views/page/hr-personal/hr-sms.vue");
const jobList = () => import("@/views/page/hr-personal/hr-job.vue");
const pageRoute: Array<RouteConfig> = [
  //PC端页面
  {
    path: "scheduleManagement",
    meta: {
      title: "行程管理",
    },
    component: scheduleManagement,
  },
  {
    path: "BookingSituation",
    meta: {
      title: "预约情况",
    },
    component: BookingSituation,
  },
  {
    path: "scheduleSummary",
    meta: {
      title: "行程总结",
    },
    component: scheduleSummary,
  },

  {
    path: "resumeManagement",
    meta: {
      title: "预约宣讲",
    },
    component: resumeManagement,
  },
  {
    path: "resumeList",
    meta: {
      title: "简历管理",
    },
    component: resumeList,
  },
  {
    path: "auditionList",
    meta: {
      title: "面试管理",
    },
    component: auditionList,
  },
  {
    path: "hrRegister",
    meta: {
      title: "hr注册",
    },
    component: hrRegister,
  },
  {
    path: "hrChangePassword",
    meta: {
      title: "hr修改密码",
    },
    component: hrChangePassword,
  },

  {
    path: "smsList",
    meta: {
      title: "短信模板",
    },
    component: smsList,
  },
  {
    path: "jobList",
    meta: {
      title: "岗位模板",
    },
    component: jobList,
  },

  {
    path: "",
    redirect: "scheduleManagement",
  },
  {
    path: "*",
    redirect: "scheduleManagement",
  },
];

export default pageRoute;
